export type DownloadFileProps = {
  /** Downloaded file name. */
  fileName: string;
  /** Text to put in file. */
  text: (() => string) | string;
};

/** Download a file onto the user's machine. */
export function downloadFile({
  fileName,
  text
}: DownloadFileProps) {
  const hiddenElement = document.createElement('a');
  hiddenElement.href = (
    'data:text/csv;charset=utf-8,'
    + encodeURIComponent(
      (typeof text === 'string') ? text : text()
    )
  );
  hiddenElement.target = '_blank';
  hiddenElement.download = fileName;
  hiddenElement.click();
}
